export default class SpecController {
  constructor($state, ProductsDataProvider) {
    "ngInject"
    this.product = ProductsDataProvider.products.findOne({slug: $state.params.product});
  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/products/components/materials/controller.js
 **/